import { useContext } from 'react';

import { WWContext, type WWContextValue } from '../components/WWContext';

import type { Gds_Event } from '../types/graphql';

export function useRsvpIsVisible(): boolean {
  const { data } = useContext<WWContextValue>(WWContext);

  // Legacy way to check if RSVP should be shown
  const anyEventsRsvpOn = data?.events?.
    filter((event: Gds_Event): boolean => event.type !== 'Reception')
    .some((event: Gds_Event): boolean => Boolean(event.requireRsvp));

  return Boolean(anyEventsRsvpOn && !data?.guestWedding?.rsvpPageHidden);
}
